var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrestoUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12019_27922",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 10,
    width: 23,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 12H15.2C14.8817 12 14.5765 12.1264 14.3515 12.3515C14.1264 12.5765 14 12.8817 14 13.2V34.8C14 35.1183 14.1264 35.4235 14.3515 35.6485C14.5765 35.8736 14.8817 36 15.2 36H32C32.3183 36 32.6235 35.8736 32.8485 35.6485C33.0736 35.4235 33.2 35.1183 33.2 34.8V13.2C33.2 12.8817 33.0736 12.5765 32.8485 12.3515C32.6235 12.1264 32.3183 12 32 12Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 27.6004H27.8063M19.4062 31.2004H23.6063M27.2063 17.4004L22.4063 22.2004L20.0063 19.8004",
    stroke: "black",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12019_27922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20312 9.59961H38.0031V38.3996H9.20312V9.59961Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrestoUsage);
export default __webpack_public_path__ + "static/media/Presto_Usage.4151defb3a3f7619716dfc3b413f6cc4.svg";
export { ForwardRef as ReactComponent };